<app-spinner-overlay></app-spinner-overlay>
@if (doppiaSurvey?.ambiti?.length) {
  @if (!_isTabCriteri) {
    <!-- Template tab assegnazioni IRO -->
    <ng-container
      [ngTemplateOutlet]="tabAssegnazioniIro"
      [ngTemplateOutletContext]="{ doppiaSurvey: doppiaSurvey }"
    ></ng-container>
  } @else if (_isTabCriteri) {
    <!-- Template tab riepilogo delle assegnazioni -->
    <ng-container
      [ngTemplateOutlet]="tabCriteriIro"
      [ngTemplateOutletContext]="{ doppiaSurvey: doppiaSurvey }"
    ></ng-container>
  }
} @else {
  NESSUN ELEMENTO CONFIGURATO
}

<!-- TEMPLATE TAB ASSEGNAZIONI IRO -->
<ng-template #tabAssegnazioniIro let-doppiaSurvey="doppiaSurvey">
  <div class="bordo">
    <ng-scrollbar>
      @for (ambito of doppiaSurvey?.ambiti; track ambito.id) {
        <div style="padding-right: 15px">
          <!-- titolo ambito  -->
          <div class="titolo-ambito">Ambito - {{ ambito.titolo }}</div>

          @for (tematica of ambito.tematiche; track tematica.id; let first = $first) {
            <div class="tematica-group">
              <!-- titolo tematica  -->
              <div [id]="ambito.id + '_' + tematica.id + 'tema'" class="domanda-tematica">
                Tematica - {{ tematica.domanda }}
              </div>

              @if (tematica?.temiIro?.length) {
                <!-- ESISTONO I TEMI QUINDI SCAVO PER TROVARE GLI ELEMENTI -->
                @for (temaIro of tematica.temiIro; track temaIro.id) {
                  <div class="tema-group">
                    <mat-label>
                      <!-- Etichetta -->
                      @if (etichetteESRS && etichetteESRS[temaIro.id]) {
                        <span class="etichetta-esrs">{{ etichetteESRS[temaIro.id] }} - </span>
                      }

                      <!-- titolo tema -->
                      <a class="titolo-tema"> {{ temaIro.nomeBreve }}</a>
                      @if (temaIro.descrizione) {
                        <a class="titolo-tema"> - {{ temaIro.descrizione }} </a>
                      }
                    </mat-label>

                    @if (_tipoIRO && temaIro[_tipoIRO].length) {
                      @for (iro of $any(temaIro[_tipoIRO]); track iro.id) {
                        <div style="display: flex; align-items: center">
                          <!-- titolo elemento -->
                          <a class="titolo-elemento">
                            {{ iro.titolo ? iro.titolo : iro.descrizione }}
                          </a>

                          <!-- assegnamento figura -->
                          <div style="display: flex; height: 40px">
                            <button
                              mat-icon-button
                              aria-label="Associa Stakeholders"
                              class="icona-figura"
                              (click)="
                                $event.stopPropagation();
                                assegnaStakeholders(ambito.id, tematica.id, temaIro.id, iro.id)
                              "
                            >
                              <mat-icon
                                class="material-icons-outlined icone-label-chack"
                                [ngClass]="{
                                  'primary-icon': isElementoAssegnato(
                                    ambito.id,
                                    tematica.id,
                                    temaIro.id,
                                    iro.id
                                  ),
                                  'default-icon': !isElementoAssegnato(
                                    ambito.id,
                                    tematica.id,
                                    temaIro.id,
                                    iro.id
                                  ),
                                }"
                              >
                                person</mat-icon
                              >
                            </button>

                            <!-- INFO VARIABILI IRO -->
                            @if (haVariabili(iro)) {
                              <span
                                class="material-icons-outlined info-variabili-icon"
                                [appTooltipOverlay]="tooltipVariabiliTemplate"
                                [variabiliTemplate]="{
                                  iro: iro,
                                  tipoIro: normalizzaTipoIro(_tipoIRO),
                                }"
                                position="right"
                              >
                                help_outline
                              </span>
                            }
                          </div>
                        </div>

                        @if (_tipoIRO === 'impattiIro') {
                          <!-- DESCRIZIONE -->
                          <div class="descrizione-elemento">{{ iro.descrizione }}</div>
                        }
                      }
                    } @else if (_tipoIRO) {
                      <div class="nessun-elemento">
                        {{ _tipoIRO === 'opportunita' ? 'NESSUNA' : 'NESSUN' }}
                        {{ mappaTipoIro[_tipoIRO].toUpperCase() }}
                      </div>
                    }
                  </div>
                }
              } @else {
                <!-- SE NON ESISTONO I TEMI ALLORA PRENDO GLI IRO DALLA TEMATICA -->
                @if (_tipoIRO && $any(tematica[_tipoIRO]).length) {
                  @for (iro of $any(tematica[_tipoIRO]); track iro.id) {
                    <div style="display: flex; align-items: center">
                      <!-- titolo elemento -->
                      <a class="titolo-elemento">
                        {{ iro.titolo ? iro.titolo : iro.descrizione }}
                      </a>

                      <!-- assegnamento figura -->
                      <div style="display: flex; height: 40px">
                        <button
                          mat-icon-button
                          aria-label="Associa Stakeholders"
                          class="icona-figura"
                          (click)="
                            $event.stopPropagation();
                            assegnaStakeholders(ambito.id, tematica.id, null, iro.id)
                          "
                        >
                          <mat-icon
                            class="material-icons-outlined icone-label-chack"
                            [ngClass]="{
                              'primary-icon': isElementoAssegnato(
                                ambito.id,
                                tematica.id,
                                null,
                                iro.id
                              ),
                              'default-icon': !isElementoAssegnato(
                                ambito.id,
                                tematica.id,
                                null,
                                iro.id
                              ),
                            }"
                          >
                            person</mat-icon
                          >
                        </button>

                        <!-- INFO VARIABILI IRO -->
                        @if (haVariabili(iro)) {
                          <span
                            class="material-icons-outlined info-variabili-icon"
                            [appTooltipOverlay]="tooltipVariabiliTemplate"
                            [variabiliTemplate]="{ iro: iro, tipoIro: normalizzaTipoIro(_tipoIRO) }"
                            position="right"
                          >
                            help_outline
                          </span>
                        }
                      </div>
                    </div>

                    @if (_tipoIRO === 'impattiIro') {
                      <!-- DESCRIZIONE -->
                      <div class="descrizione-elemento">{{ iro.descrizione }}</div>
                    }
                  }
                } @else if (_tipoIRO) {
                  <div class="nessun-elemento">
                    {{ _tipoIRO === 'opportunita' ? 'NESSUNA' : 'NESSUN' }}
                    {{ mappaTipoIro[_tipoIRO].toUpperCase() }}
                  </div>
                }
              }
            </div>
          }
        </div>
      }
    </ng-scrollbar>
  </div>
</ng-template>

<!-- TEMPLATE TAB RIEPILOGO ASSEGNAZIONI IRO -->
<ng-template #tabCriteriIro let-doppiaSurvey="doppiaSurvey">
  <div class="cnt-iro-per-criteri">
    @for (ambito of doppiaSurvey?.ambiti; track ambito.id) {
      <div style="padding-right: 15px">
        <!-- TITOLO AMBITO  -->
        <div class="titolo-ambito">Ambito - {{ ambito.titolo }}</div>

        @for (tematica of ambito.tematiche; track tematica.id; let first = $first) {
          <div class="tematica-group">
            <!-- TITOLO TEMATICA  -->
            <div [id]="ambito.id + '_' + tematica.id + 'tema'" class="domanda-tematica">
              Tematica - {{ tematica.domanda }}
            </div>
            @if (tematica.idAzienda) {
              <span class="badge-tematica-aziendale" matTooltip="Tematica aziendale">
                Aziendale
              </span>
            }

            @if (tematica?.temiIro?.length) {
              @for (temaIro of tematica.temiIro; track temaIro.id) {
                <div class="tema-group-criteri">
                  <mat-label>
                    <!-- Etichetta -->
                    @if (etichetteESRS && etichetteESRS[temaIro.id]) {
                      <span class="etichetta-esrs">{{ etichetteESRS[temaIro.id] }} - </span>
                    }
                    <!-- titolo elemento -->
                    <a class="titolo-tema"> {{ temaIro.nomeBreve }}</a>
                    @if (temaIro.descrizione) {
                      <a class="titolo-tema"> - {{ temaIro.descrizione }} </a>
                    }
                  </mat-label>

                  <!-- Accordion template -->
                  <ng-container
                    [ngTemplateOutlet]="accordionIro"
                    [ngTemplateOutletContext]="{ temaOrTematica: temaIro }"
                  ></ng-container>
                </div>
              }
            } @else {
              <!-- Accordion template -->
              <ng-container
                [ngTemplateOutlet]="accordionIro"
                [ngTemplateOutletContext]="{ temaOrTematica: tematica }"
              ></ng-container>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<!-- TEMPLATE ACCORDION -->
<ng-template #accordionIro let-temaOrTematica="temaOrTematica">
  <mat-accordion>
    @if (temaOrTematica.impattiIro.length) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Impatti </mat-panel-title>
        </mat-expansion-panel-header>

        @for (iro of temaOrTematica.impattiIro; track iro.id) {
          <div style="display: flex; align-items: center">
            <!-- titolo elemento -->
            <a class="titolo-elemento-tab-criteri"> {{ iro.titolo }} </a>

            <!-- INFO VARIABILI IRO -->
            @if (haVariabili(iro)) {
              <span
                class="material-icons-outlined info-variabili-icon"
                style="padding-left: 10px"
                [appTooltipOverlay]="tooltipVariabiliTemplate"
                [variabiliTemplate]="{ iro: iro, tipoIro: 'impatto' }"
                position="right"
              >
                help_outline
              </span>
            }
          </div>
          <!-- DESCRIZIONE -->
          <div class="descrizione-elemento-in-accordion">{{ iro.descrizione }}</div>
        }
      </mat-expansion-panel>
    }

    @if (temaOrTematica.rischi.length) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Rischi </mat-panel-title>
        </mat-expansion-panel-header>

        @for (iro of temaOrTematica.rischi; track iro.id) {
          <div style="display: flex; align-items: center">
            <!-- titolo elemento -->
            <a class="titolo-elemento-tab-criteri"> {{ iro.descrizione }} </a>

            <!-- INFO VARIABILI IRO -->
            @if (haVariabili(iro)) {
              <span
                class="material-icons-outlined info-variabili-icon"
                style="padding-left: 10px"
                [appTooltipOverlay]="tooltipVariabiliTemplate"
                [variabiliTemplate]="{ iro: iro, tipoIro: 'rischio' }"
                position="right"
              >
                help_outline
              </span>
            }
          </div>
        }
      </mat-expansion-panel>
    }

    @if (temaOrTematica.opportunita.length) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Opportunità </mat-panel-title>
        </mat-expansion-panel-header>

        @for (iro of temaOrTematica.opportunita; track iro.id) {
          <div style="display: flex; align-items: center">
            <!-- titolo elemento -->
            <a class="titolo-elemento-tab-criteri"> {{ iro.descrizione }} </a>

            <!-- INFO VARIABILI IRO -->
            @if (haVariabili(iro)) {
              <span
                class="material-icons-outlined info-variabili-icon"
                style="padding-left: 10px"
                [appTooltipOverlay]="tooltipVariabiliTemplate"
                [variabiliTemplate]="{ iro: iro, tipoIro: 'opportunita' }"
                position="right"
              >
                help_outline
              </span>
            }
          </div>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</ng-template>

<!-- TEMPLATE TOOLTIP -->
<ng-template #tooltipVariabiliTemplate let-iro="iro" let-tipoIro="tipoIro">
  <app-tooltip-variabili-iro
    #cmpTooltipVatiableIro
    [iro]="iro"
    [tipoIro]="tipoIro"
  ></app-tooltip-variabili-iro>
</ng-template>
